import angular from 'angular';
import 'angular-ui-bootstrap';

import {TagListComponent} from './tag.list.controller';
import {TagDetailsComponent} from './tag.details.component';
import TagDeleteModalController from './tag.delete.controller';
import {CreateTagComponent} from './tag.create.component';
import {TagBulkApplyComponent} from './tag.bulk.component';
import TextTableDirective from './components/text-table.component';
import RangeDirective from './components/range.component';
import NumberInputDirective from './components/number.component';
import HyperlinkTableDirective from './components/hyperlink-table.component';
import ExpandableDirective from './components/expandable.component';
import DateTimeDirective from './components/date-time.component';

const taggingModule = angular.module('admin.assets.tagging', ['ui.bootstrap']);

taggingModule
  .component('tagList', TagListComponent)
  .component('tagDetails', TagDetailsComponent)
  .component('tagBulkApply', TagBulkApplyComponent)
  .component('createTag', CreateTagComponent)
  .controller('TagDeleteModalController', TagDeleteModalController)

  .directive('textTable', TextTableDirective)
  .directive('range', RangeDirective)
  .directive('numberInput', NumberInputDirective)
  .directive('hyperlinkTable', HyperlinkTableDirective)
  .directive('expandable', ExpandableDirective)
  .directive('dateTime', DateTimeDirective);

export default taggingModule.name;
